/**
 * Pre-registered label keys — seeds the label registry at app boot so
 * /admin/labels shows the full catalog even on a first-load / hard-refresh.
 *
 * Every useLabel(key, default) call in the app should have a matching entry
 * here so the label is editable BEFORE the operator has visited that page.
 *
 * The list is intentionally curated (~40 high-visibility strings). Adding a
 * new useLabel(key, default) elsewhere in the code automatically registers
 * it too (as soon as the page renders), so this file only needs to grow
 * when we want to expose new labels for pre-visit editing.
 */
import { seedLabelDefault } from "@/lib/dynamicEngine";

const KEYS = [
  // Admin Dashboard
  ["admin_dashboard.hero.title",         "Every lead, every stack, every friction."],
  ["admin_dashboard.hero.kicker",        "// Engine Briefs · Owner Dashboard"],
  ["admin_dashboard.search.placeholder", "Search by business, name, email, industry..."],

  // Contact Detail
  ["contact_detail.contact.heading",     "// CONTACT"],
  ["contact_detail.tags.heading",        "// TAGS"],
  ["contact_detail.notes.heading",       "// ADD NOTE"],
  ["contact_detail.links.heading",       "// MICRO-LANDING PAGES"],
  ["contact_detail.files.heading",       "// FILES"],
  ["contact_detail.timeline.heading",    "// UNIFIED TIMELINE"],

  // NDS-1 · NexEngines OS
  ["nds.header.wordmark",     "NEX//"],
  ["nds.header.name",         "NexEngines"],
  ["nds.header.status",       "LIVE"],
  ["nds.header.env",          "SANDBOX"],
  ["nds.header.ops",          "OPERATING SYSTEM · NDS-1"],
  ["nds.selector.kicker",     "// SELECT INDUSTRY VERTICAL"],
  ["nds.kpi.kicker",          "// REAL-TIME KPI PULSE"],
  ["nds.kpi.live_tag",        "LIVE"],
  ["nds.kpi.demo_tag",        "DEMO"],
  ["nds.feed.heading",        "LIVE SYSTEM FEED"],
  ["nds.feed.kicker",         "streaming · every 30s"],
  ["nds.steps.kicker",        "// 10-STEP REVENUE FLOW · UNIVERSAL LIFECYCLE"],
  ["nds.steps.heading",       "Every dollar. Every step. Every vertical."],
  ["nds.caps.kicker",         "// 20-CAPABILITY PLATFORM ROADMAP"],
  ["nds.caps.heading",        "Modular capabilities. One universal grid."],
];

KEYS.forEach(([k, v]) => seedLabelDefault(k, v));

export default KEYS;
